import { useState } from "react";
import type { MaterialComparison, MaterialConfig } from "../../shared/api/kdMaterialTypes";
import type { KDLocation } from "../../shared/api/kdTypes";
import { Button, Callout } from "../../shared/ui/Primitives";
import { MaterialEntryView } from "./KDMaterialsScreen";

export function MaterialEvidence({ entry }: { entry: MaterialComparison }) {
  return <div className="stack">
    {entry.standard_check === "not_checked" && <strong>Справочная информация</strong>}
    <p>{entry.reason}</p><p>Прочитанная марка: {entry.observed.grade || "Не выделена"}</p>
    <p>{entry.observed.standards.length
      ? `Нормативные ссылки в проверяемом фрагменте: ${entry.observed.standards.join("; ")}`
      : "В проверяемом фрагменте нормативная ссылка не выделена"}</p>
    {entry.matches.map(row => <MaterialEntryView key={row.entry_id} entry={row} />)}
    {entry.candidates.length ? <><strong>Близкие записи для рассмотрения специалистом</strong>{entry.candidates.map(row => <MaterialEntryView key={row.entry_id} entry={row} />)}</> : null}
  </div>;
}

export function KDMaterialReport({ config, onSelect }: { config: MaterialConfig; onSelect: (id: string, location: KDLocation) => void }) {
  const [shown, setShown] = useState(30);
  return <details className="kd-material-report"><summary>Материалы КД · {config.title} · версия {config.revision}</summary>
    <p>В справочнике {config.entry_count} записей. Выбранная версия закреплена за этим запуском.</p>
    {config.selected_entry_ids && <p>В этой проверке выбрано {config.selected_entry_count} материалов: {config.selection_groups?.join("; ")}. Остальные не проверяются по справочнику.</p>}
    {config.files.map(f => <details key={f.id}><summary>{f.filename} · SHA-256</summary><p>{f.sha256}</p></details>)}
    {!config.report ? <p>Сверка появится после завершения обработки.</p> : <>
      {config.report.limitations.map((l, i) => <Callout key={i} tone="warning">{l}</Callout>)}
      {config.report.entries.slice(0, shown).map((entry, i) => <details key={i}><summary>{entry.observed.raw_text} · лист {entry.page} · {entry.reason}</summary>
        <MaterialEvidence entry={entry} />
        <Button variant="secondary" onClick={() => onSelect(entry.finding_id || "", { document_id: entry.document_id, page: entry.page, bbox: entry.observed.bbox as KDLocation["bbox"] })}>Место в PDF</Button>
      </details>)}
      {config.report.entries.length > shown ? <Button variant="secondary" onClick={() => setShown(shown + 30)}>Показать ещё</Button> : null}
    </>}
  </details>;
}
